export default __webpack_public_path__ + "static/media/networkVolunteer.0291c21e.PNG";